/**
 * What a shopper needs to know about a food's weight in Compras, by option
 * name (a Compras line is one name across every plan, so this can't disagree
 * between plans). `shopping-format.test.ts` pins it to the plans' data: a
 * food is "cocido" exactly when its options are weighed cooked.
 */
export interface ShoppingInfo {
  /** The grams are cooked or drained weight: what you buy weighs differently. */
  state?: "cocido" | "escurrido";
  /** One container's worth of those grams, for a "≈ N latas" hint. */
  container?: { unit: string; grams: number };
}

const COOKED: ShoppingInfo = { state: "cocido" };

export const SHOPPING_INFO: Record<string, ShoppingInfo> = {
  "Arroz blanco": COOKED,
  "Arroz integral": COOKED,
  "Fideos blancos": COOKED,
  "Fideos integrales": COOKED,
  Quinua: COOKED,
  Lentejas: COOKED,
  Frejol: COOKED,
  Garbanzo: COOKED,
  "Arvejita partida": COOKED,
  Papa: COOKED,
  Camote: COOKED,
  Yuca: COOKED,
  Choclo: COOKED,
  "Guiso (locro, olluquito, etc.)": COOKED,
  // USDA "canned in water, drained solids"; a 140 g Peruvian can drains to 100 g.
  "Atún en conserva": { state: "escurrido", container: { unit: "lata", grams: 100 } },
};
